import ModalContainer from '@commons/modal/modal-container/ModalContainer'
import ProductDisplay from '@commons/product/product-display/ProductDisplay'
import { Bundle, useModal } from '@components/featured-products/ModalContext'
import { CTAPropsWithModal } from '@components/product-portfolio/types'
import { usePbProps } from '@content/helpers/src/context.tsx'
import {
    Collapse,
    MediaModal,
    Notification
} from '@nespresso-design-system/components'
import { useRef } from 'preact/hooks'
import { addSKUtoCart } from '@content/helpers/src/updateCart'
import styles from './ProductModal.module.scss'
import CTA from '@commons/cta/CTA.tsx'

const RenderModalFooterCTA = ({
    bundlesHeadline,
    ...props
}: CTAPropsWithModal & { bundlesHeadline?: string }) => {
    const btnRef = useRef(null)

    const handleClick = async (e, props) => {
        e.preventDefault()

        const { bundles } = props
        for (const bundle of bundles) {
            const { sku, quantity } = bundle
            await addSKUtoCart(sku, quantity)
        }
    }

    return (
        <div className={styles.modalFooter}>
            <div className={styles.modalFooterPricing}>
                {bundlesHeadline && (
                    <span className="t-sm-700">{bundlesHeadline}</span>
                )}
            </div>

            <div className={styles.modalFooterATC}>
                <CTA
                    onClick={e => {
                        handleClick(e, props)
                    }}
                    {...props}
                    ref={btnRef}
                />
            </div>
        </div>
    )
}

const RenderProductsModal = ({
    bundles,
    data
}: {
    sku: string | null
    bundles: Bundle[]
    data: any
}) => {
    return (
        <>
            <Notification
                {...data?.modal?.notification}
                className={styles.modalProductsNotification}
                hasDismissButton={false}
            />

            <div className={styles.modalProductsShowcase}>
                {bundles &&
                    bundles.map(({ sku }) => (
                        <ProductDisplay sku={sku} hideATC={true} />
                    ))}
            </div>

            <Collapse
                {...data?.modal?.collapseInfo?.collapse}
                className={styles.collapse}
                content={
                    <ModalContainer
                        content={data?.modal?.collapseInfo?.modalContainer}
                    />
                }
            />
        </>
    )
}

const ProductModal = ({ categoryId }) => {
    const { copywriting, modalId }: any = usePbProps()
    const { categories, cta_primary } = copywriting
    const { isOpen, closeModal, modalData } = useModal()

    const activeCategoryData = categories.find(
        category => category.id === categoryId
    )

    return (
        <MediaModal
            className={styles.modalWrapper}
            id={modalId}
            heading={activeCategoryData?.modal?.heading}
            closeBtnA11yLabel={activeCategoryData?.modal?.closeBtnA11yLabel}
            position="side"
            isOpen={isOpen(modalId)}
            onClose={closeModal}
            fixedFooter={true}
            footerSlot={
                <RenderModalFooterCTA
                    {...cta_primary}
                    sku={modalData.sku}
                    bundles={modalData.bundles}
                    bundlesHeadline={modalData.bundleHeadline}
                />
            }
            contentSlot={
                <RenderProductsModal
                    sku={modalData.sku}
                    bundles={modalData.bundles}
                    data={activeCategoryData}
                />
            }
            heroAspectRatio="16/9"
        />
    )
}

export default ProductModal
